<template>
  <div class="sc-team">
    <div class="container">
      <h2 class="sc-title -center">Náš víťazný tím</h2>
      <div class="sc-team-inner">
      </div>
    </div>
    <div class="sc-team-imagewrap">
      <img src="@/assets/sc/team.jpg" alt="Tím" class="sc-team-image">
      <div class="sc-team-picker">
        <div
          v-for="(member, i) in members"
          :key="member.name"
          class="sc-team-head"
          :class="{
            active: i === activeIndex,
          }"
          :style="{
            left: member.coordinates.x + '%',
            top: member.coordinates.y + '%',
          }"
          @click="activeIndex = i"
        />
      </div>
      <div class="sc-team-card">
        <button class="sc-team-card-arrow -prev" @click="selectPrev"/>
        <button class="sc-team-card-arrow -next" @click="selectNext"/>
        <img class="sc-team-card-photo" :src="activeMember.photo" :alt="activeMember.name">
        <h3 class="sc-team-card-name">
          {{ activeMember.name }}
        </h3>
        <p class="sc-team-card-meta" v-html="activeMember.position"></p>
        <div class="sc-team-card-motto" v-if="activeMember.motto">
          Motto: {{ activeMember.motto }}
        </div>
        <div class="sc-team-card-about">
          {{ activeMember.about }}
        </div>
        <UButton
          v-if="!activeMember.hideButton"
          block
          @click="$emit('cv-open')"
        >
          Chcem sa pridať
        </UButton>
      </div>
    </div>
  </div>
</template>

<script>
import UButton from '@/components/UButton.vue';

export default {
  components: {
    UButton,
  },
  data() {
    return {
      members: [
        {
          name: 'Miloš Ernihold',
          position: 'Krajský riaditeľ,<br> Žilinský kraj',
          motto: 'Aby ste boli v biznise úspešní, musíte mať svoje srdce vo svojom biznise a váš biznis vo svojom srdci',
          about: 'Vo finančníctve pôsobím od roku 1996. Dnes si už ani neviem predstaviť, že by som robil niečo iné. Hľadám ľudí, ktorí sú vytrvalí, pretože táto práca je beh na dlhú trať. Ľudí, ktorí majú v sebe energiu a elán ísť do nových vecí, neustále sa učiť a pracovať na svojom osobnostnom raste.',
          photo: require('@/assets/team/ernihold.jpg'),
          coordinates: { x: 44.5, y: 6.5 },
        },
        {
          name: 'Miroslav Sedmák',
          position: 'Krajský riaditeľ,<br> Bratislavský a Trnavský kraj',
          motto: 'Neprežije najsilnejší ani najinteligentnejší, ale ten, kto sa vie najlepšie prispôsobiť.',
          about: 'V bankovo-poistnom sektore pracujem už 26 rokov, z toho posledných 15 rokov v spoločnosti Wüstenrot. Hľadám nadšených obchodníkov a odvážnych manažérov, ktorí sú tímoví hráči, majú radi výzvy a sú vytrvalí. Nováčikov zaškolíme, skúsených podporíme v profesionálnom raste.',
          photo: require('@/assets/team/sedmak.jpg'),
          coordinates: { x: 49.5, y: 5 },
        },
        {
          name: 'Lucia Horníčková',
          position: 'Krajská riaditeľka,<br> Trenčiansky kraj',
          motto: 'Kto nepozná prístav, do ktorého sa chce plaviť, tomu nie je žiadny vietor priaznivý (Seneca)',
          about: 'Stereotypy dnešnej doby mi nič nehovoria a nové výzvy sú mojou dennou rutinou. Naučila som sa adekvátne vnímať samú seba, pochopiť svoje slabosti a, samozrejme, neustále získavať nové vedomosti a zručnosti. Preto k nám hľadáme podobných ľudí. Ľudí, ktorí nachádzajú potešenie v nových veciach, ktorí sa nenechajú znechutiť, keď sa niečo nepodarí hneď na prvýkrát. Hľadáme lídrov, ktorí majú pozitívne myslenie, tímového ducha a vedia prirodzene viesť tím ľudí.',
          photo: require('@/assets/team/hornickova.jpg'),
          coordinates: { x: 52.5, y: 16 },
        },
        {
          name: 'Vladimír Leško',
          position: 'Krajský riaditeľ,<br> Prešovský kraj',
          motto: 'Nehľadajme výhovorky, hľadajme riešenia!',
          about: 'Nepatrím medzi tých, čo sa len vezú. Neustále hľadám cestu, ako zvládnuť hocijakú výzvu a potiahnuť celý tím. Väčšina ľudí z Prešovského kraja má šikovnosť a pracovitosť priamo v DNA. Chcem, aby za úspechom nemuseli vycestovať, ale aby ho mohli dosiahnuť doma vo svojom kraji.',
          photo: require('@/assets/team/lesko.jpg'),
          coordinates: { x: 56.5, y: 10 },
        },

        {
          name: 'Marian Hrotka',
          position: 'Predseda predstavenstva',
          motto: 'Niekde uprostred problému vždy stojí príležitosť (Albert Einstein)',
          about: 'Marian Hrotka je absolventom Ekonomickej univerzity v Bratislave, kde študoval poistnú matematiku a získal doktorát zo štatistiky. V praxi nadobudol bohaté skúsenosti v oblasti poisťovníctva, strategického plánovania, riadenia obchodu a financií. Má skúsenosti s produktovými inováciami, start-up projektmi, budovaním tímov a rozvíjaním obchodných vzťahov, a to nielen na Slovensku, ale aj v zahraničí (Taliansko, Česká republika, Bulharsko, Rakúsko, Luxembursko). Je skúseným a rešpektovaným manažérom na medzinárodnej úrovni.',
          photo: require('@/assets/team/hrotka.jpg'),
          coordinates: { x: 61.7, y: 9.5 },
          hideButton: true,
        },
        {
          name: 'Jaro Sýkora',
          position: 'Riaditeľ obchodu',
          motto: 'Zákazník je spolucestujúci na pár minút. Klient je partner na dlhé trasy',
          about: 'Svoju kariéru som naštartoval vo Wüstenrot pred dvadsiatimi rokmi. A stále si pamätám svoje prvé kilometre na trase W1. Dnes hľadáme spolujazdcov po celom Slovensku, ktorým pomôžeme naštartovať ich kariéru.',
          photo: require('@/assets/team/sykora.jpg'),
          coordinates: { x: 68, y: 9.5 },
          hideButton: true,
        },

        {
          name: 'Peter Sabo',
          position: 'Krajský riaditeľ,<br> Nitriansky kraj',
          motto: 'Ľuďom nechávam priestor na sebarealizáciu, pričom rád poradím a pomôžem s tým, s čím potrebujú',
          about: 'Pre Wüstenrot pracujem viac ako 21 rokov. Prešiel som viacerými pozíciami, takže prácu vo Wüstenrote poznám dokonale. Hľadám do nášho tímu mladých, perspektívnych a akčných ľudí, ktorí majú chuť niečo v živote dosiahnuť.',
          photo: require('@/assets/team/sabo.jpg'),
          coordinates: { x: 73.5, y: 10 },
        },
        {
          name: 'Jana Bič',
          position: 'Krajská riaditeľka,<br> Košický kraj',
          motto: 'Úspech nášho kraja je odrazom proklientského prístupu našich manažérov a obchodníkov ku klientom',
          about: 'Záleží nám na spokojnosti klienta od prvého kontaktu až po chvíle, kedy už reálne využíva výhody našich služieb. Vďaka tejto filozofii sme schopní i v týchto neľahkých časoch rozširovať náš tím o nových členov a o nové pracovné pozície.',
          photo: require('@/assets/team/bic.jpg'),
          coordinates: { x: 79, y: 13 },
        },
        {
          name: 'Ján Tesár',
          position: 'Krajský riaditeľ,<br> Banskobystrický kraj',
          motto: 'Nemožne na počkanie a zázraky do troch dní',
          about: 'Vo Wüstenrote pracujem od roku 2002 a stále ju považujem za best spoločnosť, pretože spolupracujem so skvelými ľuďmi, na ktorých sa môžem vždy spoľahnúť. V Banskobystrickom kraji hľadáme ľudí, ktorí majú radi iných, neboja sa vziať svoj život do svojich rúk a niesť za neho zodpovednosť.',
          photo: require('@/assets/team/tesar.jpg'),
          coordinates: { x: 84, y: 7 },
        },
      ],
      activeIndex: 0,
    };
  },
  computed: {
    membersWithPhotos() {
      return this.members.map((member) => ({
        ...member,
        // eslint-disable-next-line import/no-dynamic-require
        photoSource: require(`@/assets/team/${member.photo}`),
      }));
    },
    activeMember() {
      return this.members[this.activeIndex];
    },
  },
  methods: {
    selectNext() {
      const maxIndex = this.members.length - 1;
      this.activeIndex = this.activeIndex < maxIndex
        ? this.activeIndex + 1
        : 0;
    },
    selectPrev() {
      this.activeIndex = this.activeIndex !== 0
        ? this.activeIndex - 1
        : this.members.length + 1;
    },

  },
};
</script>

<style lang="scss">
.sc-team {
  margin-bottom: 150px;
  .sc-team-imagewrap {
    margin-top: 100px;
    position: relative;
  }
  .sc-team-image {
    display: none;
    width: 100%;
    height: auto;
  }
  .sc-team-card {
    position: relative;;
    margin: 0 40px;
  }
  .sc-team-picker {
    display: none;
  }
  @media screen and (min-width: $screen-md) {
    .sc-team-image {
      display: block;
      width: 100%;
      height: auto;
    }
    .sc-team-card {
      position: absolute;
      left: calc(20% - 220px);
      width: 380px;
      min-height: 570px;
      top: -40px;
    }
    .sc-team-picker {
      display: block;
    }
  }
}

.sc-team-card {
  background-color: white;
  border: 2px solid $gray-200;
  padding: 20px;
  display: flex;
  flex-direction: column;
  @media screen and (min-width: $screen-md) {
    padding: 25px;
  }
  .sc-team-card-photo {
    display: block;
    width: 120px;
    height: auto;
    margin-bottom: 15px;
    box-shadow: 6px -6px $primary;
  }
  .sc-team-card-name {
    color: $primary;
    font-size: 30px;
    margin-bottom: 10px;
  }
  .sc-team-card-meta {
    font-weight: 700;
    margin-bottom: 20px;
  }
  .sc-team-card-motto {
    color: $gray-400;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .sc-team-card-about {
    margin-bottom: 20px;
    font-size: 14px;
    flex: 1;
  }
  .sc-team-card-arrow {
    @include reset-button;
    position: absolute;
    top: 60px;
    width: 36px;
    height: 36px;
    background-color: rgba(white, 0.35);
    background-image: url('../assets/inlineicons/caret-right.svg');
    background-position: center;
    background-repeat: no-repeat;
    filter: invert(1);
    &.-prev {
      left: -30px;
      transform: scale(-1);
    }
    &.-next {
      right: -30px;
    }
    @media screen and (min-width: $screen-md) {
      top: 170px;
      &.-prev {
        left: -48px;
      }
      &.-next {
        right: -48px;
      }
    }
  }
}

.sc-team-head {
  position: absolute;
  width: 4vw;
  height: 4vw;
  border: 3px solid rgba(black, 0.2);
  box-shadow: 0 5px 20px rgba(black, 0.2);
  cursor: pointer;
  &::before {
    content: "";
    position: absolute;
    left: -2px;
    top: -2px;
    bottom: -2px;
    right: -2px;
    border: 1px solid rgba(white, 0.4);
  }
  &.active::before {
    border: 1px solid white;
  }
}

</style>
